import { InvoiceByJobFilters as Filters } from './useInvoiceByJobFilters'
import { DatePicker, Tooltip } from 'antd'
import dayjs from 'dayjs'
const { RangePicker } = DatePicker

type FieldsProps = { filters: Filters }

const DateRangeFilter = ({ filters, style, dateHelp }: FieldsProps & { style?: React.CSSProperties; dateHelp?: string }) => {
  const { dateRange } = filters.state

  return <Tooltip title={dateHelp}>
    <span style={{ display: 'inline-block', ...style }}>
      <RangePicker
        style={style ? { width: '100%' } : undefined}
        value={[
          dateRange.starting ? dayjs(dateRange.starting) : null,
          dateRange.ending ? dayjs(dateRange.ending) : null
        ]}
        onChange={(range) => {
          if (range) {
            filters.setDateRange(range[0]?.format('MM/DD/YYYY') ?? null, range[1]?.format('MM/DD/YYYY') ?? null)
          } else {
            filters.setDateRange(null, null)
          }
        }}
      />
    </span>
  </Tooltip>
}


export default DateRangeFilter
